import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useBrowserDetection } from "../../hooks/useBrowserDetection";
import * as Styled from "./CircularProgress.styled";
export const CircularProgress = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { color, size = 40, hasBackground, palette = "expressiveInformative", variant = "determinate", colorScheme, ...otherProps } = props;
    const { isIE11 } = useBrowserDetection();
    const strokeWidth = size / 16;
    const center = size / 2;
    const radius = center - strokeWidth;
    const loadingIndicator = isIE11 ? (_jsxs(Styled.IE11Loader, { "data-testid": "CircularProgressIE11", ref: ref, color: color, hasBackground: hasBackground, height: size, width: size, palette: palette, "aria-hidden": "true", focusable: "false", ...otherProps, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] })) : (_jsx(Styled.CircleSvg, { "data-testid": "CircularProgress", ref: ref, height: size, width: size, variant: variant, "aria-hidden": "true", focusable: "false", ...otherProps, children: _jsx(Styled.Circle, { cx: center, cy: center, r: radius, fill: "none", palette: palette, color: color, colorScheme: colorScheme, hasBackground: hasBackground, strokeWidth: strokeWidth, variant: variant }) }));
    if (hasBackground) {
        const wrapperSize = size < 20 ? size + 8 : size + 16;
        return (_jsx(Styled.CircleWrapper, { palette: palette, colorScheme: colorScheme, color: color, size: wrapperSize, children: loadingIndicator }));
    }
    return loadingIndicator;
});
CircularProgress.displayName = "CircularProgress";
CircularProgress.defaultProps = {
    size: 40,
    palette: "expressiveInformative",
    variant: "determinate"
};
